import { useEffect, useState } from "react";
import { ResolveUrl, ResolvePath, ResolveStorageUrl, GetCachedUrls } from "features/firebase-app";
import { makeCancelable } from "./util";

export default function RedQuickImage(props: any) {
    const [source, setSource] = useState(null);
    useEffect(() => {
        let removed = false;
        let count = 100;
        if (props.src) {
            setSource(GetCachedUrls(props.src) || props.src);
            if (!GetCachedUrls(props.src)) {
                makeCancelable(ResolveStorageUrl(props.src).then((res) => {
                    if (res) {
                        setSource(res);
                    }
                    else {
                        let getCached = () => {
                            if (!removed) {
                                let url = GetCachedUrls(props.src);
                                if (url) {
                                    setSource(url)
                                }
                                else {
                                    count--;
                                    if (count) {
                                        setTimeout(getCached, 1000);
                                    }
                                }
                            }
                        };
                        setTimeout(getCached, 1000);
                    }
                }));
            }
        }
        return () => {
            removed = true;
        }
    }, [props.src, GetCachedUrls(props.src)]);
    let args = { ...props };
    delete args.src;

    return <img src={source} {...args} />
}

